"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _bind = Function.prototype.bind;
exports["default"] = Factory;

function Factory(Factory) {
    var factory = function factory() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var instance = new (_bind.apply(Factory, [null].concat(args)))();

        var linkOrg = instance.link;
        if (linkOrg) {
            instance.link = function () {
                var instance = new (_bind.apply(Factory, [null].concat(args)))();

                for (var _len2 = arguments.length, linkArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    linkArgs[_key2] = arguments[_key2];
                }

                linkOrg.apply(instance, linkArgs);
            };
        }

        /*
        if (instance.controller) {
            instance.controller = function(controllerOrg) {
                return function(...controllerArgs) {
                    console.log(['in', controllerOrg]);
                    
                    var instance = new Factory(...args);
                    controllerOrg.apply(instance, controllerArgs);
                    console.log(['out', controllerOrg]);
                };
            }(instance.controller);
            
            instance.controller.$inject = instance.controller.$inject || ['$scope', '$element'];
        }
        */

        return instance;
    };

    factory.$inject = Factory.$inject || [];

    return factory;
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/utils/factory.js
 ** module id = 42
 ** module chunks = 0
 **/